export default __webpack_public_path__ + "static/media/car.cd0e06f3.svg";